import { useState } from "react";
import {
  UsersApi,
  RequestDeleteUserRequestWrapper,
  UsersDeleteUserPostRequest,
} from "../../services/OpenAPI";
import { createConfiguration } from "./common";

export const useApiDeleteUser = () => {
  const [deleteUserResult, setDeleteUserResult] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const deleteUsers = async (req: RequestDeleteUserRequestWrapper) => {
    setIsLoading(true);
    setError(null);

    try {
      setIsLoading(true);
      const config = createConfiguration();
      const request: UsersDeleteUserPostRequest = {
        wrapperReq: req,
      };
      const api = new UsersApi(config);
      const response = await api.usersDeleteUserPost(request);
      setDeleteUserResult(response);
      return response;
    } catch (err) {
      setError("ユーザー削除に失敗しました");
      console.error(err);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { deleteUsers, error, isLoading };
};
